import React from 'react'
import PropTypes from 'prop-types'

export const BoxLayout = ({ children }) => (
  <div className="igdas-modal">
    {children}
  </div>
)

BoxLayout.propTypes = {
  children : PropTypes.element.isRequired
}

export default BoxLayout



// WEBPACK FOOTER //
// ./src/layouts/BoxLayout/BoxLayout.js